import { render, staticRenderFns } from "./clienteFormulario.vue?vue&type=template&id=5af86fe7&"
import script from "./clienteFormulario.vue?vue&type=script&lang=ts&"
export * from "./clienteFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports